import type { ReactNode } from 'react'

import { ModuleAccessRoute } from '@/lib/app/module-access-route'
import { useFeatureFlagEnabled } from '@/lib/config/featureflag'

export const OutreachCampaignsModuleRoute = ({ children }: { children: ReactNode }) => {
  const { isEnabled, isLoading } = useFeatureFlagEnabled('outreach-campaigns')
  return (
    <ModuleAccessRoute hasAccess={isEnabled} isLoading={isLoading}>
      {children}
    </ModuleAccessRoute>
  )
}
